var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextMenuGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 3H15a1 1 0 011 1v2H1V3a1 1 0 011-1h4.323a1 1 0 01.929.629L7.4 3z",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.35,
    d: "M.5 6.5h16l-1 8h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.323 2a1 1 0 01.929.629L7.4 3H15a1 1 0 011 1v2h-.03a1 1 0 01.993 1.121l-.855 7a1 1 0 01-.993.879H1.885a1 1 0 01-.992-.879l-.856-7A1 1 0 011.03 6H1V3a1 1 0 011-1h4.323zm9.648 5H1.03l.855 7h13.23l.855-7zM6.323 3H2v3h13V4H7.4a1 1 0 01-.928-.629L6.323 3z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenuGroup);
export default __webpack_public_path__ + "static/media/context-menu-group.40ca3a43.svg";
export { ForwardRef as ReactComponent };